module.exports = __webpack_public_path__ + "static/media/Cube-1s-264px.1e796d8d.gif";